import { render, staticRenderFns } from "./BaseInputRadio.vue?vue&type=template&id=055a7252&scoped=true&"
import script from "./BaseInputRadio.vue?vue&type=script&lang=ts&"
export * from "./BaseInputRadio.vue?vue&type=script&lang=ts&"
import style0 from "./BaseInputRadio.vue?vue&type=style&index=0&id=055a7252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055a7252",
  null
  
)

export default component.exports